export const SHOWN_ALL_PHOTOS_COUNT = 4;
